(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9664],{

/***/ 72661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _getMelbourneTimezoneMoment = _interopRequireDefault(__webpack_require__(80605));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var timezonePlaceholderSerializer = function timezonePlaceholderSerializer(_ref) {
  var placeholders = _ref.placeholders;
  return function (value) {
    var matchedPlaceholder = (0, _fp.find)({
      _id: (0, _fp.get)('node._ref', value)
    }, placeholders);
    var placeholderId = (0, _fp.get)('identifier.current', matchedPlaceholder);
    if (placeholderId === 'australian-eastern-time') {
      return (0, _getMelbourneTimezoneMoment["default"])().format('zz');
    }
    return '';
  };
};
var _default = exports["default"] = timezonePlaceholderSerializer;
module.exports = exports.default;

/***/ }),

/***/ 68442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13294);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ahmdigital_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51036);
/* harmony import */ var _ahmdigital_analytics__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_analytics__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36456);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93590);
/* harmony import */ var _models_lead_capture_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1329);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81653);
/* harmony import */ var _actions_drawer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56774);
/* harmony import */ var _lead_capture_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85230);
/* harmony import */ var _actions_request_a_call__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18374);
/* harmony import */ var _selectors_select_current_drawer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(84466);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(91229);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_13__);














var RequestACallDrawer = function() {
    var closeDrawerDelay = 2000;
    var requestACall = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.requestACall;
    });
    var drawer = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_selectors_select_current_drawer__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var captureRequestACall = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        _actions_request_a_call__WEBPACK_IMPORTED_MODULE_11__/* ["default"].drawerCapture */ .Z.drawerCapture()(dispatch);
    }, [
        dispatch
    ]);
    var closeGetACallBackDrawer = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        _actions_drawer__WEBPACK_IMPORTED_MODULE_9__/* ["default"].closeDrawer */ .Z.closeDrawer()(dispatch);
        _actions_request_a_call__WEBPACK_IMPORTED_MODULE_11__/* ["default"].drawerDismiss */ .Z.drawerDismiss()(dispatch);
    }, [
        dispatch
    ]);
    var failed = requestACall.failed, recordId = requestACall.recordId, submitted = requestACall.submitted;
    var _REQUEST_A_CALL = _models_lead_capture_constants__WEBPACK_IMPORTED_MODULE_7__/* .LEAD_MESSAGES.REQUEST_A_CALL */ .W.REQUEST_A_CALL, message = _REQUEST_A_CALL.message, requiredFieldsMessage = _REQUEST_A_CALL.requiredFieldsMessage, submitButtonText = _REQUEST_A_CALL.submitButtonText, title = _REQUEST_A_CALL.title;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), loading = ref[0], setLoading = ref[1];
    var isOpen = drawer === _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_6__.DRAWER_IDS.GET_A_CALL_BACK;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var onRequestACallSubmit = function(values) {
        setLoading(true);
        _ahmdigital_analytics__WEBPACK_IMPORTED_MODULE_3__.tagmanager.submit("request_a_callback", {
            // eslint-disable-next-line camelcase
            is_member: values.isMember ? "yes" : "no"
        });
        captureRequestACall();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (submitted && recordId) {
            setLoading(false);
            setTimeout(closeGetACallBackDrawer, closeDrawerDelay);
        }
        if (failed) setLoading(false);
    }, [
        closeGetACallBackDrawer,
        failed,
        recordId,
        submitted
    ]);
    var requestACallFormContainer = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            failed && _constants__WEBPACK_IMPORTED_MODULE_8__/* .productPageFailedMessage */ .FZ,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.H1, {
                looksLike: "h4",
                variant: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_13___default().text),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.P, {
                variant: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_13___default().text),
                children: message
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Small */ .x4, {
                variant: [
                    "small14",
                    (_styles_module_sass__WEBPACK_IMPORTED_MODULE_13___default().text),
                    (_styles_module_sass__WEBPACK_IMPORTED_MODULE_13___default().small)
                ],
                children: requiredFieldsMessage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lead_capture_form__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                leadType: _models_lead_capture_constants__WEBPACK_IMPORTED_MODULE_7__/* .LEAD_TYPES.REQUEST_A_CALL */ .s.REQUEST_A_CALL,
                onSubmit: onRequestACallSubmit,
                sourceType: _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_2__.LEAD_SOURCE_TYPES.REQUEST_A_CALL,
                submitButtonText: submitButtonText,
                isLoading: loading
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Drawer */ .dy, {
        title: "",
        isOpen: isOpen,
        toggleMenu: closeGetACallBackDrawer,
        children: submitted && recordId ? _constants__WEBPACK_IMPORTED_MODULE_8__/* .productPageSuccessMessage */ .Ym : requestACallFormContainer
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RequestACallDrawer);


/***/ }),

/***/ 34427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M7": function() { return /* binding */ firstRowId; },
/* harmony export */   "bP": function() { return /* binding */ focusVisible; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ahmdigital_icons_web__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87379);
/* harmony import */ var _analytics_delacon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(275);
/* harmony import */ var _utils_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85500);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :focus-visible {\n    outline: 2px dotted ",
        ";\n    outline-offset: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        " {\n      padding: 1rem 1.5rem;\n      font-size: 20px;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0.5rem;\n  padding: 0.75rem 1.25rem;\n  max-width: max-content;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        " {\n      margin: 5rem 0 1.75rem;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 2.5rem 0 0.75rem;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        " {\n      margin-top: 5.5rem;\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 2.875rem;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}








var focusVisible = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.grey50;
});
var DecisionButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx).withConfig({
    componentId: "sc-58522e04-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject1(), theme.mediaQueries.above(theme.media.sm));
});
var BranchHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__.H2).withConfig({
    componentId: "sc-58522e04-1"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), theme.mediaQueries.above(theme.media.sm));
}, focusVisible);
var IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    componentId: "sc-58522e04-2"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5(), theme.mediaQueries.above(theme.media.sm));
});
var firstRowId = "firstRow";
// @ts-expect-error - Automatic, Please fix when editing this file
var Branch = function(param) {
    var onSelect = param.onSelect, _selected = param.selected, selected = _selected === void 0 ? null : _selected, _branches = param.branches, branches = _branches === void 0 ? null : _branches, _branchHeading = param.branchHeading, branchHeading = _branchHeading === void 0 ? null : _branchHeading;
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (selected && "object" !== "undefined") {
            var reloadDelacon = window.plaPageReload;
            if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_3__.isFunction)(reloadDelacon)) {
                reloadDelacon(_analytics_delacon__WEBPACK_IMPORTED_MODULE_6__/* .DELACON.companyId */ .X.companyId);
            }
        }
    }, [
        selected
    ]);
    // @ts-expect-error - Automatic, Please fix when editing this file
    var decisionButtonHandler = function(item, content) {
        return function() {
            // @ts-expect-error - Automatic, Please fix when editing this file
            onSelect(item, content);
        };
    };
    var arrowOnClickHandler = function() {
        (0,_utils_ui__WEBPACK_IMPORTED_MODULE_7__/* .scrollToElement */ .kI)(document.getElementById(firstRowId));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .SpacerWrapper */ .Cj, {
        children: [
            branchHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
                lgHorizontalAlign: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BranchHeading, {
                    looksLike: "h4",
                    id: branchHeading,
                    tabIndex: "0",
                    children: branchHeading
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
                lgHorizontalAlign: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                    md: 12,
                    df: 6,
                    children: !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(branches) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
                        lgHorizontalAlign: "center",
                        children: selected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DecisionButton, {
                            onClick: decisionButtonHandler(null),
                            variant: [
                                "purple",
                                "rounded",
                                "thinBorder",
                                "purpleHover"
                            ],
                            children: selected.content.title
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_3__.map)(function(param) {
                                var content = param.content, id = param.id;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DecisionButton, {
                                    onClick: decisionButtonHandler(id, content),
                                    variant: [
                                        "border",
                                        "transparentBlack",
                                        "rounded",
                                        "thinBorder",
                                        "shadowHover"
                                    ],
                                    children: content.title
                                }, id);
                            }, branches)
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
                        lgHorizontalAlign: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconContainer, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Clickable */ .P3, {
                                "aria-label": "Scroll down",
                                isUnstyled: true,
                                onClick: arrowOnClickHandler,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_icons_web__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                    name: "arrow-down",
                                    width: 24,
                                    height: 24
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Branch);


/***/ }),

/***/ 53753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ contact_options; },
  "e": function() { return /* binding */ optionConstantIds; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/pages/contact-us/components/branch/index.tsx
var branch = __webpack_require__(34427);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/contact-options/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    margin-bottom: 2.5rem;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: ",
        ") {\n    padding: 0 0.5rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  padding: 4rem 0;\n\n  @media (min-width: ",
        ") {\n    padding: 5.5rem 0;\n  }\n\n  @media (min-width: ",
        ") {\n    padding: 7.5rem 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  @media (min-width: ",
        ") {\n    width: 75%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  padding: 0.5rem 0 1.5rem;\n\n  @media (min-width: ",
        ") {\n    padding: 1.25rem 0 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.75rem 1.5rem;\n\n  @media (min-width: ",
        ") {\n    padding: 1.85rem 1.25rem;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var Heading = (0,styled_components_browser_esm["default"])(ahm_ui.H2).withConfig({
    componentId: "sc-c7985551-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, branch/* focusVisible */.bP);
var AlertSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-c7985551-1"
})(_templateObject1());
var AlertWrapper = (0,styled_components_browser_esm["default"])(ahm_ui/* Wrapper */.im).withConfig({
    componentId: "sc-c7985551-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var OptionsSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-c7985551-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
}, function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var OptionsContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c7985551-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var OptionsRow = (0,styled_components_browser_esm["default"])(ahm_ui/* Row */.X2).withConfig({
    componentId: "sc-c7985551-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var OptionColumn = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-c7985551-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});

// EXTERNAL MODULE: ./src/client/models/url/constants.ts
var constants = __webpack_require__(772);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/contact-option/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    height: 100%;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  height: 100%;\n  padding: 1.5rem 2.5rem;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: auto;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var OptionContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-64a27368-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var OptionBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-64a27368-1"
})(styles_templateObject1(), function(param) {
    var isHighlighted = param.isHighlighted, colors = param.theme.colors;
    return isHighlighted ? colors.purpleTint : colors.grey10;
}, function(param) {
    var isHighlighted = param.isHighlighted, colors = param.theme.colors;
    return isHighlighted ? colors.purple : colors.grey10;
});
var OptionContentRow = (0,styled_components_browser_esm["default"])(ahm_ui/* Row */.X2).withConfig({
    componentId: "sc-64a27368-2"
})(styles_templateObject2());
var OptionButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-64a27368-3"
})(styles_templateObject3());

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/contact-option/index.tsx





var ContactOption = function(param) {
    var buttonOnClick = param.buttonOnClick, buttonText = param.buttonText, buttonUrl = param.buttonUrl, _isButtonDisabled = param.isButtonDisabled, isButtonDisabled = _isButtonDisabled === void 0 ? false : _isButtonDisabled, subText = param.subText, title = param.title, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionBox, {
            "data-testid": "optionBox",
            isHighlighted: isHighlighted,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionContentRow, {
                    variant: "paddingBottomSpacer6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                            looksLike: "h4",
                            variant: [
                                "marginBottomSpacer11"
                            ],
                            children: title
                        }),
                        (0,fp.map)(function(text) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                variant: [
                                    "small14",
                                    "withoutMargin"
                                ],
                                children: text
                            }, text);
                        })(subText)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionContentRow, {
                    variant: "paddingBottomSpacer11",
                    children: (buttonUrl || buttonOnClick) && buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionButton, {
                        onClick: buttonOnClick,
                        to: buttonUrl,
                        size: "auto",
                        disabled: isButtonDisabled,
                        children: buttonText
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var contact_option = (ContactOption);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/actions/drawer/index.ts
var drawer = __webpack_require__(56774);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/contact-options/get-a-call-back/index.tsx






var GetACallBack = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var openGetACallBackDrawer = (0,react.useCallback)(function() {
        drawer/* default.openDrawer */.Z.openDrawer(ui.DRAWER_IDS.GET_A_CALL_BACK)(dispatch);
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_option, {
        buttonText: "Call me back",
        buttonOnClick: openGetACallBackDrawer,
        subText: [
            "Fill in the form and one of our helpful humans will call you back as soon as possible."
        ],
        title: "Get a callback"
    });
};
/* harmony default export */ var get_a_call_back = (GetACallBack);

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/livechat/lib/actions/index.js
var actions = __webpack_require__(88530);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/live-chat/styles.ts

function live_chat_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  top: -2.5rem;\n\n  @media (min-width: ",
        ") {\n    position: absolute;\n  }\n"
    ]);
    live_chat_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function live_chat_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    live_chat_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function live_chat_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 0.45rem;\n"
    ]);
    live_chat_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function live_chat_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: auto;\n  margin-top: 0.75rem;\n"
    ]);
    live_chat_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var CalloutSection = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1773bc56-0"
})(live_chat_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var CalloutText = (0,styled_components_browser_esm["default"])(ahm_ui.H4).withConfig({
    componentId: "sc-1773bc56-1"
})(live_chat_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.purple;
});
var CalloutArrow = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-1773bc56-2"
})(live_chat_styles_templateObject2());
var StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-1773bc56-3"
})(live_chat_styles_templateObject3());

;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/live-chat/images/arrow-illo-down.svg
/* harmony default export */ var arrow_illo_down = ({"src":"/_next/static/media/arrow-illo-down.7f6657dc.svg","height":22,"width":25});
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/utils/livechat.ts
var livechat = __webpack_require__(47689);
// EXTERNAL MODULE: ./src/client/components/live-chat/live-chat-status/index.tsx + 1 modules
var live_chat_status = __webpack_require__(26183);
// EXTERNAL MODULE: ./src/client/components/live-chat/use-live-chat/index.ts
var use_live_chat = __webpack_require__(22303);
;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/live-chat/index.tsx




// @ts-expect-error - Automatic, Please fix when editing this file









var LiveChat = function(param) {
    var actions = param.actions, chatType = param.chatType, offline = param.offline, online = param.online;
    var ref = (0,use_live_chat/* default */.Z)(), isAbcSupportedAndAvailable = ref.isAbcSupportedAndAvailable, isOnline = ref.isOnline, messageId = ref.messageId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionContainer, {
        children: [
            chatType === "currentMember" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalloutSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CalloutText, {
                        looksLike: "h5",
                        variant: "simpleBit",
                        children: "Skip the phone queues"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CalloutArrow, {
                        src: arrow_illo_down.src,
                        alt: "Arrow pointing down"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionBox, {
                "data-testid": "optionBox",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionContentRow, {
                        variant: "paddingBottomSpacer6",
                        children: chatType === "lookingToJoin" && !isAbcSupportedAndAvailable && !isOnline ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                                    looksLike: "h4",
                                    variant: [
                                        "marginBottomSpacer11"
                                    ],
                                    children: offline.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    variant: [
                                        "small14",
                                        "withoutMargin"
                                    ],
                                    children: offline.subText
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                                    looksLike: "h4",
                                    variant: [
                                        "marginBottomSpacer11"
                                    ],
                                    children: online.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    variant: [
                                        "small14",
                                        "withoutMargin"
                                    ],
                                    children: online.subText
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionContentRow, {
                        variant: "paddingBottomSpacer11",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(live_chat_status/* default */.Z, {
                                    isOnline: isOnline
                                }),
                                isAbcSupportedAndAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                    to: "".concat(ahm_constants/* default.URLS.THIRD_PARTY.APPLE_BUSINESS_CHAT */.Z.URLS.THIRD_PARTY.APPLE_BUSINESS_CHAT).concat(messageId),
                                    children: isOnline ? online.buttonText : offline.buttonText
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: isOnline ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        onClick: function() {
                                            return actions.launch(livechat/* default */.Z);
                                        },
                                        children: online.buttonText
                                    }) : chatType === "lookingToJoin" && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        to: offline.buttonUrl,
                                        children: offline.buttonText
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)(actions/* default */.Z, dispatch)
    };
};
/* harmony default export */ var live_chat = ((0,es/* connect */.$j)(null, mapDispatchToProps)(LiveChat));


;// CONCATENATED MODULE: ./src/client/pages/contact-us/components/contact-options/index.tsx










var optionConstantIds = {
    callUs: "callUs",
    currentMemberChatBox: "currentMemberChatBox",
    getACallBack: "getACallBack",
    lookingToJoinChatBox: "lookingToJoinChatBox",
    memberLogIn: "memberLogIn"
};
var CallUs = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_option, {
        buttonText: data.buttonText,
        buttonUrl: data.buttonUrl,
        subText: data.subText,
        title: data.title
    });
};
var CurrentMemberChatBox = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(live_chat, (0,_object_spread/* default */.Z)({
        chatType: "currentMember"
    }, data));
};
var LookingToJoinChatBox = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(live_chat, (0,_object_spread/* default */.Z)({
        chatType: "lookingToJoin"
    }, data));
};
var MemberLogIn = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_option, {
        buttonText: "Member log in",
        buttonUrl: constants.URLS.MEMBERS.HOME,
        isHighlighted: true,
        subText: [
            "Check annual limits, claim for extras, update your details, find information about your policy and more.", 
        ],
        title: "Manage your cover online"
    });
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getComponentHandler = function(param) {
    var contactOptionData = param.contactOptionData, contactOptionId = param.contactOptionId;
    switch(contactOptionId){
        case optionConstantIds.callUs:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CallUs, {
                data: contactOptionData
            });
        case optionConstantIds.currentMemberChatBox:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentMemberChatBox, {
                data: contactOptionData
            });
        case optionConstantIds.getACallBack:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(get_a_call_back, {});
        case optionConstantIds.lookingToJoinChatBox:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LookingToJoinChatBox, {
                data: contactOptionData
            });
        case optionConstantIds.memberLogIn:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberLogIn, {});
        default:
            return null;
    }
};
var AlertMessage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Alert */.bZ, {
        heading: "There are long waits to chat to us right now due to high call volumes",
        level: "info",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
            children: [
                "Skip the call queue and get it done in a flash online! You can always",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                    to: constants.URLS.MEMBERS.HOME,
                    children: "log in"
                }),
                " to check your limits, claim for extras, update payment details, update your income tier or find information about your policy. We may also answered your question in our handing ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                    to: constants.URLS.HELP.HOME,
                    children: "help section"
                }),
                "."
            ]
        })
    });
};
var ContactOptions = function(param) {
    var options = param.options, _showAlertMessage = param.showAlertMessage, showAlertMessage = _showAlertMessage === void 0 ? false : _showAlertMessage, _title = param.title, title = _title === void 0 ? "Didn’t find what you’re after?" : _title, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showAlertMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertSection, {
                variant: [
                    "regular",
                    "marginTopSpacer3"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                            id: id,
                            tabIndex: "0",
                            variant: [
                                "center",
                                "marginBottomSpacer10"
                            ],
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsRow, {
                            children: (0,fp.map)(function(param) {
                                var contactOptionId = param.contactOptionId, contactOptionData = param.contactOptionData;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionColumn, {
                                    df: 4,
                                    sm: 12,
                                    children: getComponentHandler({
                                        contactOptionData: contactOptionData,
                                        contactOptionId: contactOptionId
                                    })
                                }, contactOptionId);
                            })(options)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                            variant: [
                                "marginTopSpacer12",
                                "center"
                            ],
                            children: [
                                "Submit feedback:\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                    to: constants.URLS.HELP.COMPLAINTS,
                                    children: "Find out more"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var contact_options = (ContactOptions);


/***/ }),

/***/ 56515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ CONTACT_OPTION_ID; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_timezone_placeholder_serializer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72661);
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_timezone_placeholder_serializer__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_utils_sanity_timezone_placeholder_serializer__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _contact_options__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53753);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10453);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83202);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_7__);








var CONTACT_OPTION_ID = {
    CURRENT_MEMBER: "current member",
    LOOKING_TO_JOIN: "Get in touch about joining"
};
var getSubText = function(param) {
    var placeholders = param.placeholders, source = param.source;
    return [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .PortableText */ .YI, {
            source: source,
            typeSerializers: {
                placeholder: _ahmdigital_logic_lib_utils_sanity_timezone_placeholder_serializer__WEBPACK_IMPORTED_MODULE_4___default()({
                    placeholders: placeholders
                })
            },
            variant: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_7___default().withoutMargin)
        }), 
    ];
};
var formatContactOptions = function(param) {
    var _appendCustomOptions = param.appendCustomOptions, appendCustomOptions = _appendCustomOptions === void 0 ? false : _appendCustomOptions, _customOptions = param.customOptions, customOptions = _customOptions === void 0 ? [] : _customOptions, id = param.id, items = param.items, placeholders = param.placeholders, title = param.title;
    var contacts = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.flatMap)("item", items);
    var isLookingToJoin = id === CONTACT_OPTION_ID.LOOKING_TO_JOIN;
    var chatOfflineItem = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.find)({
        type: "chat-offline"
    }, contacts);
    var chatOnlineItem = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.find)({
        type: "chat-online"
    }, contacts);
    var chatOption = {
        contactOptionData: {
            offline: chatOfflineItem ? {
                buttonText: chatOfflineItem.action,
                buttonUrl: "sms:".concat(chatOfflineItem.phoneNumber),
                subText: getSubText({
                    placeholders: placeholders,
                    source: chatOfflineItem.descriptionRaw
                }),
                title: chatOfflineItem.title
            } : {
                buttonText: "Leave a message",
                buttonUrl: "sms:".concat(_ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CONTACT.PHONE.SMS_STANDARD */ .Z.CONTACT.PHONE.SMS_STANDARD),
                subText: "Thinking about joining ahm? Send us a message and we’ll get back to you as soon as we’re back online. ".concat(_ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CONTACT.PHONE.SMS_PRETTY */ .Z.CONTACT.PHONE.SMS_PRETTY),
                title: "SMS us"
            },
            online: chatOnlineItem ? {
                buttonText: chatOnlineItem.action,
                subText: getSubText({
                    placeholders: placeholders,
                    source: chatOnlineItem.descriptionRaw
                }),
                title: chatOnlineItem.title
            } : {
                buttonText: "Start chat",
                subText: "8am – 7pm Monday to Friday (AET).",
                title: "Message us"
            }
        },
        contactOptionId: isLookingToJoin ? _contact_options__WEBPACK_IMPORTED_MODULE_5__/* .optionConstantIds.lookingToJoinChatBox */ .e.lookingToJoinChatBox : _contact_options__WEBPACK_IMPORTED_MODULE_5__/* .optionConstantIds.currentMemberChatBox */ .e.currentMemberChatBox
    };
    var callUsItem = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.find)({
        type: "phone"
    }, contacts);
    var callUsOption = {
        contactOptionData: callUsItem ? {
            buttonText: callUsItem.action,
            buttonUrl: "tel:".concat(callUsItem.phoneNumber),
            subText: getSubText({
                placeholders: placeholders,
                source: callUsItem.descriptionRaw
            }),
            title: callUsItem.title
        } : {
            buttonText: "Call ".concat(_ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CONTACT.PHONE.PRETTY */ .Z.CONTACT.PHONE.PRETTY),
            buttonUrl: "tel:".concat(_ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CONTACT.PHONE.STANDARD */ .Z.CONTACT.PHONE.STANDARD),
            subText: [
                "".concat(_ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CONTACT.PHONE.PRETTY */ .Z.CONTACT.PHONE.PRETTY),
                "9am – 6pm Monday to Friday (AEST).",
                "Calling from overseas? ".concat(_ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CONTACT.PHONE.INTERNATIONAL_PRETTY */ .Z.CONTACT.PHONE.INTERNATIONAL_PRETTY), 
            ],
            title: "Call us"
        },
        contactOptionId: _contact_options__WEBPACK_IMPORTED_MODULE_5__/* .optionConstantIds.callUs */ .e.callUs
    };
    return {
        id: id,
        options: appendCustomOptions ? (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.concat)([
            chatOption,
            callUsOption
        ], customOptions) : (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.concat)(customOptions, [
            chatOption,
            callUsOption
        ]),
        showAlertMessage: false,
        title: title
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (formatContactOptions);


/***/ }),

/***/ 91229:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","text":"styles_text__TqRUu","small":"styles_small__MNKSc"};

/***/ }),

/***/ 83202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","withoutMargin":"styles_withoutMargin__uMAPv"};

/***/ })

}]);